import { createComponent as createFelaComponent } from 'react-fela'; // eslint-disable-line behance/no-deprecated
import { hocDisplayName, addDisplayName } from './displayName';
export var getDisplayName = hocDisplayName('FelaComponent');

//similar to react-fela's createComponent. However, it automatically adds PropTypes from `[type]`
//in case that it is a React Component.
//Adds a displayName to the created component and provides a way to setDisplayName again outside of the call

//You should use this HOC every time when you want to use Fela in your component.
var createComponent = function createComponent(rule) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
  var passThroughProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var Component = createFelaComponent(rule, type, type.propTypes ? passThroughProps.concat(Object.keys(type.propTypes)) : passThroughProps);

  addDisplayName(Component, type, getDisplayName);
  return Component;
};

export default createComponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/cf-component-request-status-indicator/node_modules/@cloudflare/style-container/es/createComponent.js
// module id = 642
// module chunks = 1